import React, { useEffect, useState } from 'react';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import configData from '../../configData.json';

const LocationManager = ({ cust, setGridData, onUpdateGridData, gridData, handleAddRow, row }) => {
    const [locationNameOptions, setLocationNameOptions] = useState([]);
    const [locationTypeOptions, setLocationTypeOptions] = useState([]);
    const [selectedLocationType, setSelectedLocationType] = useState(null);
    const [selectedLocationName, setSelectedLocationName] = useState(null);

    const onLocationTypeSelect = async (selectedValue) => {
        if (!row) {
            handleAddRow();
        }
        const selectedType = locationTypeOptions.find(option => option.value === selectedValue);
        setGridData(gridData => {
            const updatedData = gridData.map(item => {
                let isLocationTypeChanged = item.locationType !== selectedValue;

                let dirtyFlag = item.dirtyFlag;
                if (item.isNew && isLocationTypeChanged) {
                    dirtyFlag = 'I';
                } else if (isLocationTypeChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    locationType: selectedValue,
                    locationTypeName: selectedType ? selectedType.name : null,
                    locationKey: null,
                    locationDesc: null,
                    dirtyFlag,
                };
            });

            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        })
        setSelectedLocationType(selectedValue);
        setSelectedLocationName(null);
        await LoadLocationName(cust, selectedValue);
    };

    const onLocationNameSelect = (selectedValue) => {
        const selectedName = locationNameOptions.find(option => option.value === selectedValue);

        const updatedData = gridData.map(item => {
            let isLocationNameChanged = item.locationKey !== selectedValue;

            let dirtyFlag = item.dirtyFlag;
            if (item.isNew && isLocationNameChanged) {
                dirtyFlag = 'I';
            } else if (isLocationNameChanged) {
                dirtyFlag = 'U';
            }

            return {
                ...item,
                locationKey: selectedValue,
                locationDesc: selectedName ? selectedName.name : null,
                dirtyFlag,
            };
        });

        setGridData(updatedData);
        onUpdateGridData(updatedData);
        setSelectedLocationName(selectedValue);
    };

    const LoadLocationType = async () => {
        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationType`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token'),
                },
            });

            const data = await response.json();

            let locationTypeOptions = data.map(locationType => ({
                name: locationType.codeDesc, // Store name
                value: locationType.codeID, // Store value
            }));

            locationTypeOptions.unshift({ name: "-- Select A Value --", value: 0 });
            setLocationTypeOptions(locationTypeOptions);
        } catch (error) {
            console.error('Error loading location types:', error);
        }
    };

    const LoadLocationName = async (custkey, locTypeCode) => {
        if (!locTypeCode || locTypeCode === 0) return;

        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationName/${custkey}/${locTypeCode}`;

        try {
            let locationNameOptions = [];
            if (["DIV", "REG", "BRA"].includes(locTypeCode)) {
                const response = await fetch(URL, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token'),
                    },
                });

                const data = await response.json();
                locationNameOptions = data.map(locationName => ({
                    name: locationName.value, // Store name
                    value: locationName.key, // Store value
                }));
            }

            locationNameOptions.unshift({ name: "-- Select A Value --", value: 0 });
            setLocationNameOptions(locationNameOptions);
        } catch (error) {
            console.error('Error loading location names:', error);
        }
    };

    useEffect(() => {
        LoadLocationType();
    }, []);

    useEffect(() => {
        if (gridData.length > 0 && gridData[0].locationType) {
            setSelectedLocationType(gridData[0].locationType);
            LoadLocationName(cust, gridData[0].locationType);
            setSelectedLocationName(gridData[0].locationKey);
        } else {
            setSelectedLocationType(null);
            setSelectedLocationName(null);
            setLocationNameOptions([])
        }
    }, [gridData]);

    return (
        <>
            <div className='col-4 col-xs-12'>
                <div className='row g-0 mb-2'>
                    <div className='col-md-6 col-xs-12'>
                        <label>Location Type:<label className="text-danger">*</label></label>
                    </div>
                    <div className='col-md-6 col-xs-12'>
                        <SelectSearch
                            id="ddnLocationType"
                            name="ddnLocationType"
                            value={selectedLocationType || 0}
                            options={locationTypeOptions}
                            onChange={onLocationTypeSelect}
                            search
                            filterOptions={fuzzySearch}
                            style={{ width: '220px' }}
                        />
                    </div>
                </div>
            </div>
            <div className='col-4 col-xs-12'>
                <div className='row mb-2'>
                    <div className='col-md-4 col-xs-12 ps-4 pe-0'>
                        <label>Location Name:<label className="text-danger">*</label></label>
                    </div>
                    <div className='col-md-8 ps-4 pe-0 col-xs-12'>
                        <SelectSearch
                            id="ddnLocationName"
                            name="ddnLocationName"
                            value={selectedLocationName || 0}
                            options={locationNameOptions}
                            onChange={onLocationNameSelect}
                            search
                            filterOptions={fuzzySearch}
                            style={{ width: '220px' }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LocationManager;
